import { Box, Text, } from '@chakra-ui/react';
import React from 'react';

const PreviewAwards = ({ items }) => {

  return (
      <Box className="contentBox" _last={{borderBottom:'none'}}>
        {Object.values(items).map((item) => {
             return (
                <Text className='subSections' >
                  <Text  className="name">{item.award_name}</Text>
                  <Text>{item.award_org}</Text>
                  <Text>{item.award_type}</Text>
                </Text>
            );
          },
        )}
      </Box>
  );
};
export default PreviewAwards;
